export default __webpack_public_path__ + "static/media/collapse-icon.111844d6.svg";